import easyCheckApi from '../api/config';

const BASE_URL = '/cheque-collections';

export const chequeCollectionService = {
  getCollections: async (params = {}) => {
    try {
      const response = await easyCheckApi.get(BASE_URL, { params });
      const data = response.data;
      return {
        success: data.Success ?? data.success ?? true,
        data: data.Data ?? data.data ?? [],
        totalCount: data.TotalCount ?? data.totalCount ?? 0,
        pageNumber: data.PageNumber ?? data.pageNumber ?? 1,
        pageSize: data.PageSize ?? data.pageSize ?? 20,
        totalPages: data.TotalPages ?? data.totalPages ?? 0,
        message: data.Message ?? data.message ?? '',
      };
    } catch (error) {
      console.error('Failed to fetch collections:', error);
      return {
        success: false,
        data: [],
        totalCount: 0,
        message: error.response?.data?.Message || error.response?.data?.message || 'Failed to fetch collections',
      };
    }
  },

  getSummary: async () => {
    try {
      const response = await easyCheckApi.get(`${BASE_URL}/summary`);
      const data = response.data;
      return {
        success: data.Success ?? data.success ?? true,
        data: data.Data ?? data.data ?? {},
      };
    } catch (error) {
      console.error('Failed to fetch collection summary:', error);
      return {
        success: false,
        data: { AwaitingCount: 0, DispatchedCount: 0, CollectedTodayCount: 0, ReturnedThisWeekCount: 0 },
      };
    }
  },

  getCollectionDetail: async (id) => {
    try {
      const response = await easyCheckApi.get(`${BASE_URL}/${id}`);
      const data = response.data;
      return {
        success: data.Success ?? data.success ?? true,
        data: data.Data ?? data.data ?? null,
      };
    } catch (error) {
      console.error('Failed to fetch collection detail:', error);
      return {
        success: false,
        data: null,
        message: error.response?.data?.Message || error.response?.data?.message || 'Failed to fetch detail',
      };
    }
  },

  walkinCollection: async (request) => {
    try {
      const response = await easyCheckApi.post(`${BASE_URL}/walkin`, request);
      const data = response.data;
      return {
        success: data.Success ?? data.success ?? true,
        data: data.Data ?? data.data ?? null,
        message: data.Message ?? data.message ?? 'Walk-in collection recorded',
      };
    } catch (error) {
      console.error('Failed to record walk-in collection:', error);
      return {
        success: false,
        message: error.response?.data?.Message || error.response?.data?.message || 'Failed to record collection',
      };
    }
  },

  dispatchCourier: async (request) => {
    try {
      const response = await easyCheckApi.post(`${BASE_URL}/dispatch`, request);
      const data = response.data;
      return {
        success: data.Success ?? data.success ?? true,
        data: data.Data ?? data.data ?? null,
        message: data.Message ?? data.message ?? 'Courier dispatch recorded',
      };
    } catch (error) {
      console.error('Failed to record dispatch:', error);
      return {
        success: false,
        message: error.response?.data?.Message || error.response?.data?.message || 'Failed to record dispatch',
      };
    }
  },

  confirmDelivery: async (request) => {
    try {
      const response = await easyCheckApi.post(`${BASE_URL}/deliver`, request);
      const data = response.data;
      return {
        success: data.Success ?? data.success ?? true,
        message: data.Message ?? data.message ?? 'Delivery confirmed',
      };
    } catch (error) {
      console.error('Failed to confirm delivery:', error);
      return {
        success: false,
        message: error.response?.data?.Message || error.response?.data?.message || 'Failed to confirm delivery',
      };
    }
  },

  markReturned: async (request) => {
    try {
      const response = await easyCheckApi.post(`${BASE_URL}/return`, request);
      const data = response.data;
      return {
        success: data.Success ?? data.success ?? true,
        message: data.Message ?? data.message ?? 'Cheque marked as returned',
      };
    } catch (error) {
      console.error('Failed to mark as returned:', error);
      return {
        success: false,
        message: error.response?.data?.Message || error.response?.data?.message || 'Failed to mark as returned',
      };
    }
  },
};

export default chequeCollectionService;
